import React from 'react';
import FontAwesome from 'react-fontawesome';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

import './Carousel.sass';

export interface IDisplayProps {
    activeItem: number;
    children: React.ReactNode;
    name: string;
    leftArrowClicked(event: React.MouseEvent<any>): void;   // Redux dispatchers go here
    rightArrowClicked(event: React.MouseEvent<any>): void;  // <--
    didMount(): void; // Use these to inject redux dispatcher into lifecycle functions
    willUnMount(): void; // <--
}

interface IDisplayState {
    carouselDirection: string;
    containerHeight: number;
    disableScroll: boolean;
}

class Carousel extends React.Component<IDisplayProps, IDisplayState> {
    public activeItemDiv: HTMLDivElement;

    constructor(props: IDisplayProps) {
        super(props);

        this.componentWillUnmount = props.willUnMount;

        this.state = {
            carouselDirection: 'right',
            containerHeight: 0,
            disableScroll: false
        };

        this.onArrowClickWrapper = this.onArrowClickWrapper.bind(this);
    }

    public componentDidMount() {
        this.setState({ containerHeight: this.activeItemDiv.clientHeight }, this.props.didMount);
        this.autoRotate();
    }

    public componentDidUpdate(prevProps: IDisplayProps) {
        if (this.props.activeItem !== prevProps.activeItem && this.activeItemDiv.offsetHeight > 0) {
            this.setState({ containerHeight: this.activeItemDiv.clientHeight });
        }
    }

    public onArrowClickWrapper(handler: React.MouseEventHandler<any>): React.MouseEventHandler<any> {
        return (event: React.MouseEvent<any>) => {
            this.setState({ disableScroll: true, carouselDirection: event.currentTarget.className.includes('Left-arrow') ? 'left' : 'right' }, () => handler(event));
        };
    }

    public autoRotate()  {
        if (!this.state.disableScroll) {
            const timer = setTimeout(
                () => {
                    this.rotate();
                    this.autoRotate();
                },
                5000
            );
        }
    }

    public rotate() {
        if (!this.state.disableScroll) {
            this.props.rightArrowClicked(null);
        }
    }

    public render() {
        return(
            <div className={`Carousel-container-${this.state.carouselDirection}`} style={{ height: this.state.containerHeight }} >
                <FontAwesome onClick={this.onArrowClickWrapper(this.props.leftArrowClicked)} className="Left-arrow" name="chevron-left" />
                <FontAwesome onClick={this.onArrowClickWrapper(this.props.rightArrowClicked)} className="Right-arrow" name="chevron-right" />
                <TransitionGroup>
                    {React.Children.map(this.props.children, (child: React.ReactElement<any>, index: number) => {
                        return index !== this.props.activeItem ?
                            (null)
                            :
                            (<CSSTransition
                                key={index}
                                classNames="Carousel-transition"
                                timeout={{ enter: 500, exit: 500 }}
                            >
                                <div ref={item => this.activeItemDiv = item} className="Carousel-item-active">{child}</div>
                            </CSSTransition>);
                    })}
                </TransitionGroup>
            </div>
        );
    }
}

const StatelessCarouselWrapper: React.StatelessComponent<IDisplayProps> = (props: IDisplayProps) => {
    return (
        <Carousel {...props} >
        {props.children}
        </Carousel>
    );
};

export default StatelessCarouselWrapper;



// WEBPACK FOOTER //
// ./src/components/global/application/Carousel.tsx